module.exports = __webpack_public_path__ + "img/Inflammation-PRCA_10X_AIC.3db3d8bf.png";